// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ElipseOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_2421_10266)"},"children":[{"tag":"path","attrs":{"d":"M17.75 16.6a9.64 9.64 0 01-11.5 0c-3.18-2.54-3.18-6.66 0-9.2a9.64 9.64 0 0111.5 0c3.18 2.54 3.18 6.66 0 9.2","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","stroke":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_2421_10266"},"children":[{"tag":"rect","attrs":{"fill":"currentColor","height":"24","rx":"2","width":"24"}}]}]}]},"name":"elipse","theme":"outlined"};

const ElipseOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ElipseOutlinedSvg} />;
  ElipseOutlined.displayName = 'ElipseOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ElipseOutlined);
